import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { height, Stack } from "@mui/system";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Description,
  Divider,
  Header,
  InstructionWrapper,
  ModalWrapper,
  Title,
} from "../style/modalStyle";
import CustomButton from "./CustomButton";
import { DownArrowIconBlueLIne } from "../../assets/Icon/ArrowIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import { Box, Button, CircularProgress } from "@mui/material";

interface InstructionSet {
  title?: string;
  heading?: string; // Optional property
  instructions?: string[];
}
interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  data?: InstructionSet[];
  title?: string;
  desc?: string;
  isSs4?: boolean;
  children?: React.ReactNode;
  btnTitle?: string;
  btnTitle2?: string;
  handleSubmit?: () => void;
  loading?: boolean;
}


export default function CommonTaxModal(props: ModalPropType) {
  const { open, handleClose, title, children, btnTitle, btnTitle2, handleSubmit, loading } = props;

  return (
    <>
      <Modal
        sx={{}} 
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalWrapper>
          <CloseButtonWrapper>
            <CloseButton onClick={handleClose}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Header>
            <DownArrowIconBlueLIne />
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: 700,
              }}
            >
              {title}
              {/* Signature Instruction */}
            </Typography>
          </Header>
          <Divider />

          <Content >
            {children}
            
          </Content>
          <ButtonWrapper onClick={handleClose} isTax>
            <Button variant="outlined" onClick={handleClose}>{btnTitle2 || "Cancel"}</Button>
            <Button variant="contained" onClick={handleSubmit} disabled={loading}>{loading ? (
        <CircularProgress
          size={24}
          sx={{
            "& svg": {
              stroke: "url(#gradientColor)",
            },
          }}
        />
      ) : (
        btnTitle
      )}</Button>
             
            
          </ButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
}
